import { memo } from 'react'
import cn from 'classnames'

import { Text } from '~/shared/ui/Text'

import type { BadgeProps } from './types'

import styles from './Badge.module.scss'

/** Маленькая плашка-статус (спека 01, компонент 31). */
export const Badge = memo(function Badge(props: BadgeProps) {
  const { theme = 'NEUTRAL', size = 'M', isSolid = false, text } = props

  return (
    <span
      className={cn(
        styles.root,
        styles[`theme_${theme}`],
        styles[`size_${size}`],
        isSolid && styles.isSolid,
      )}
    >
      <Text variant={size === 'S' ? 'MICRO' : 'CAPTION'} color='INHERIT'>
        {text}
      </Text>
    </span>
  )
})
